import React from 'react';
import { Radio, Row } from 'antd';
import { RadioChangeEvent } from "antd/es/radio";

interface CustomRadioProps{
  className?: string,
  title: string,
  values: any,
  value: any,
  onChange: any,
  error: any,
}

export default function CustomRadio({
  className, title, values, onChange, error, value,
}:CustomRadioProps) {
  return (
    <div className={`${className || ''} flexCol`}>
      <p>{title}</p>
      <div className="customMarginTop">
        <Radio.Group
          onChange={(e: RadioChangeEvent) => onChange(e.target.value)}
          defaultValue={value}
        >
          { values.map(({ valor, descripcion }: any) => (
            <Row key={valor}>
              <Radio value={valor}>{descripcion}</Radio>
            </Row>
          )) }
        </Radio.Group>
      </div>
      <div>
        {(error && (
          <p className="errors">{error.message}</p>
        ))
        }
      </div>
    </div>
  );
}
